export default "__VITE_ASSET__DHM03tYJ__"